import {
    Component, OnInit, Input, OnDestroy,
    AfterViewInit, ChangeDetectionStrategy,
    ChangeDetectorRef, ViewChild, SimpleChanges, OnChanges
} from '@angular/core';
// Animations
import { slideInDownAnimation } from '../../../app/app.animation';

import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import * as moment from 'moment';
import { SelectionModel } from '@angular/cdk/collections';
import * as fromEinConfiguration from '../../../screens/ein-configuration/state/ein-configuration.selectors';
import * as EinConfigurationAction from '../../../screens/ein-configuration/state/ein-configuration.actions';
import * as _ from 'lodash';
import { Store } from '@ngrx/store';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { AngularMaterialService, LGEDataService } from 'src/commons';

@Component({
    selector: 'ein-config-table-component',
    templateUrl: 'ein-config-table.component.html',
    styleUrls: ['ein-config-table.component.scss'],
    animations: [slideInDownAnimation],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EINConfigTableComponent implements OnInit, OnChanges {
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    @Input() data: any[];
    @Input() tableType: string;

    datePipe = new DatePipe('en-US');
    public dataSource: MatTableDataSource<any>;
    selection = new SelectionModel<any>(true, []);

    public confirm: any;
    selectedRequests = [];
    isShowVAlidate = false;
    isAllChecked: boolean = false;
    isIndeterminate: boolean = false;
    isDeleting = false;
    isValidating = false;
    localData = [];
    einFilter = '';
    displayedColumns = ['EIN', 'orgName', 'subsection_501', 'address1', 'address2', 'city', 'state', 'zipCode', 'lastUpdated', 'action'];

    constructor(
        private store: Store<fromEinConfiguration.State>,
        private ref: ChangeDetectorRef,
        private route: ActivatedRoute,
        private ams: AngularMaterialService,
        private _dataService: LGEDataService,
        private router: Router
    ) {
    }
    public ngOnInit() {
        setTimeout(() => {
            this.localData = this.data;
            this.buildDataSource(this.localData);
        });
    }

    public ngOnChanges(changes: SimpleChanges) {
        // console.log(changes);
        if (changes['data']) {
            setTimeout(() => {
                this.localData = changes['data'].currentValue;
                this.buildDataSource(this.localData);
                this.selection.clear();

            });
        }

    }

    buildDataSource(data: any) {
        if (this.tableType === 'exception') {
            this.einFilter = this._dataService.getEINExceptionFilter() !== undefined? this._dataService.getEINExceptionFilter(): '';
            this.displayedColumns = ['EIN', 'orgName', 'subsection_501', 'address1', 'address2', 'city', 'state', 'zipCode', 'validationStatus', 'lastUpdated', 'action'];
        } else
            this.displayedColumns = ['EIN', 'orgName', 'subsection_501', 'address1', 'address2', 'city', 'state', 'zipCode', 'lastUpdated', 'action'];
        const filter = this.dataSource !== undefined ? (this.einFilter !== '' ? this.einFilter : this.dataSource.filter) : '';
        this.dataSource = new MatTableDataSource(data);

        this.dataSource.sortingDataAccessor = (item, property) => {
            switch (property) {
                case 'subsection_501': return isNaN(item.subsection_501) ? item.subsection_501 : +item.subsection_501;
                case 'lastUpdated': return new Date(item.lastUpdated);
                case 'isValid': return item.isValid === 1 ? 'Valid' : 'Expired';
                default: return item[property];
            }
        };
        this.dataSource.filterPredicate = (data, filter: string) => {
            const accumulator = (currentTerm, key) => {
                switch (key) {
                    case 'subsection_501':
                        return currentTerm + this.getTaxExemptStatus(data[key]);
                    case 'lastUpdated':
                        const newDate = this.datePipe.transform(data.lastUpdated, 'MM-dd-yyyy');
                        return currentTerm + newDate.toString();
                    case 'isValid':
                        return currentTerm + (data.isValid === 1 ? 'Valid' : 'Expired');
                    default:
                        return currentTerm + data[key];
                }
                // return key === 'OrgInfo' ? currentTerm + data.OrgInfo.name : currentTerm + data[key];
            };
            const dataStr = Object.keys(data).reduce(accumulator, '').toLowerCase();
            // Transform the filter by converting it to lowercase and removing whitespace.
            const transformedFilter = filter.trim().toLowerCase();
            return dataStr.includes(transformedFilter);
        };
        this.dataSource.filter = filter;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.clearToggle();
    }

    isAllSelected() {
        let isAll = false;

        isAll = this.localData !== undefined ? this.localData.length === this.selection.selected.length : false;

        this.isAllChecked = this.selection.hasValue() && isAll;
        this.isIndeterminate = this.selection.hasValue() && !isAll;
    }

    /** Selects all rows if they are not all selected; otherwise clear selection. */
    masterToggle(event) {
        if (this.isAllChecked) {
            this.clearToggle();
        } else {
            this.dataSource.filteredData.forEach(row => this.selection.select(row));
        }
        this.isAllSelected();
        // this.selectedRequests = isChecked ? this.dataSource.data.map(obj => ({ ...obj })) : [];
        // this.isShowVAlidate = this.selectedRequests.length === 0 ? false : true;
    }

    requestChecked(row) {
        this.selection.toggle(row);
        this.isAllSelected();
    }

    clearToggle() {
        this.selection.clear();
        this.isAllSelected();
    }

    getTaxExemptStatus(value) {
        if (value === '')
            return 'Other';
        else if (isNaN(value) || +value === 0) {
            return value;
        } else {
            return `501(c)(${+value})`;
        }
    }

    addEinOrgInfo() {
        // console.log('einOrgDetail', this.einOrgDetail);

        let einOrgInfo: any = {};
        einOrgInfo.ein = '';
        einOrgInfo.organization_name = '';
        einOrgInfo.address_line1 = '';
        einOrgInfo.address_line2 = '';
        einOrgInfo.city = '';
        einOrgInfo.state = '';
        einOrgInfo.zip = '';
        einOrgInfo.isException = 1;
        einOrgInfo.isValid = 1;
        einOrgInfo.lastUpdated = new Date();
        einOrgInfo.einOrgInfoId = null;
        einOrgInfo.subsection_501 = '';
        einOrgInfo.deleteIt = false;

        this.ams.showEinOrgDetail('Organization Info', 'Organization Info', einOrgInfo, this.localData, true);
        // this.ams.einOrgDetail.afterClosed().subscribe(result => {
        //     if (result) {
        //         // console.log(result);
        //         this.ams.showLoader('Loading...');
        //         this._dataService.EINOrgInfoDetailIUD(result)
        //             .then((response) => {
        //                 this.ams.closeDialog();
        //                 if (response) {
        //                     this.ams.showAlert('Success!', 'Successfully saved!');
        //                 }
        //             }, error => {
        //                 // console.log(error);
        //                 this.ams.closeDialog();
        //                 this.ams.showAlert('Error!', error);
        //                 this.ref.markForCheck();
        //             })
        //     }
        // })
    }

    onDelete(row) {
        this.isDeleting = true;

        this.ams.showConfirm(`Are you sure to delete this ${row.isException ? 'exception EIN' : 'EIN entry'}?`, ' ');
        this.ams.confirm.afterClosed().subscribe(result => {
            if (result === 'yes') {
                let einOrgInfo: any = {};
                einOrgInfo.ein = row.ein;
                einOrgInfo.organization_name = row.organization_name;
                einOrgInfo.address_line1 = row.address_line1;
                einOrgInfo.address_line2 = row.address_line2;
                einOrgInfo.city = row.city;
                einOrgInfo.state = row.state;
                einOrgInfo.zip = row.zip;
                einOrgInfo.isException = row.isException;
                einOrgInfo.lastUpdated = row.lastUpdated;
                einOrgInfo.einOrgInfoId = row.einOrgInfoId;
                einOrgInfo.subsection_501 = row.subsection_501
                einOrgInfo.deleteIt = true;
                this.store.dispatch(new EinConfigurationAction.SaveEINOrgDetail(einOrgInfo));
            }
            this.isDeleting = false;
        });
    }

    selectRow(row) {
        // console.log('einOrgDetail', this.einOrgDetail);
        if (!this.isValidating && !this.isDeleting) {
            let einOrgInfo: any = {};
            einOrgInfo.ein = row.ein;
            einOrgInfo.organization_name = row.organization_name;
            einOrgInfo.address_line1 = row.address_line1;
            einOrgInfo.address_line2 = row.address_line2;
            einOrgInfo.city = row.city;
            einOrgInfo.state = row.state;
            einOrgInfo.zip = row.zip;
            einOrgInfo.isException = row.isException;
            einOrgInfo.isValid = row.isValid;
            einOrgInfo.lastUpdated = row.lastUpdated;
            einOrgInfo.einOrgInfoId = row.einOrgInfoId;
            einOrgInfo.subsection_501 = row.subsection_501
            einOrgInfo.deleteIt = false;

            this.ams.showEinOrgDetail('Organization Info', 'Organization Info', einOrgInfo, this.localData, row.isException === 1);
        }
    }

    public applyFilter(filterValue: string) {
        filterValue = filterValue.trim();
        filterValue = filterValue.toLowerCase();
        this.dataSource.filter = filterValue;
        this._dataService.setEINExceptionFilter('');
    }


}